import { TIME_FILTER_OPTIONS } from 'Explore/Config/constraint'
import styles from './TimeFilter.module.scss'
import { Select } from 'antd'

const TimeFilter = ({
  showTitle,
  timeFilter,
  setTimeFilter,
}) => {
  return (
    <div className={styles["time-filter"]}>
      {showTitle && <p className={styles["time-filter--title"]}>Filter by: </p>}
      <Select
        value={timeFilter}
        style={{ width: 140 }}
        onChange={(value) => setTimeFilter(value)}
        options={TIME_FILTER_OPTIONS}
      />
    </div>
  )
}

export default TimeFilter